<template>
	<button
		:class="[
			'button',
			className,
			disabled || loading ? 'disabled' : '',
			theme,
		]"
		@click="$emit('click', $event)"
		:disabled="disabled || loading"
	>
		<div v-if="loading" class="button__loader-container">
			<div class="button__loader"></div>
		</div>
		<slot v-if="!loading">{{ text }}</slot>
	</button>
</template>

<script>
export const ButtonThemes = Object.freeze({
	PRIMARY: 'primary',
	SMALL_GRADIENT: 'small_gradient',
	RESET: 'reset',
	BACK: 'back',
	BORDER_PRIMARY: 'border_primary',
	TAB: 'tab',
});

export default {
	name: 'BaseButton',
	props: {
		text: { type: String, default: '' },
		loading: { type: Boolean, default: false },
		disabled: { type: Boolean, default: false },
		className: { type: String, default: '' },
		theme: {
			type: ButtonThemes,
			default: ButtonThemes.PRIMARY,
			validator: (v) => Object.values(ButtonThemes).includes(v),
		},
		cornerColor: { type: String, default: '#15CA5C' },
		hasArrow: { type: Boolean, default: false },
		useFrame: { type: Boolean, default: true },
		wrapperClass: { type: String, default: '' },
		wrapperStyle: { type: Object, default: () => ({}) },
	},
	emits: ['click'],
};
</script>
